import React from "react";
import { Repeat, EyeOff, HeartCrack, RotateCw } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const ICONS = [Repeat, EyeOff, HeartCrack, RotateCw];
const SPANS = ["lg:col-span-2", "lg:col-span-1", "lg:col-span-1", "lg:col-span-2"];

export default function ProblemSection() {
  const { t } = useLanguage();
  const cards = t("problem.cards") || [];

  return (
    <section
      id="problem"
      className="bg-[#F9F8F6] py-20 sm:py-28 lg:py-36"
      data-testid="problem-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="reveal max-w-3xl mb-16 lg:mb-20">
          <p className="text-xs uppercase tracking-[0.24em] text-[#0B2545] font-sans-display mb-4">
            {t("problem.eyebrow")}
          </p>
          <h2 className="font-sans-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0F172A] leading-[1.1]">
            {t("problem.h2a")}
            <span className="block text-[#475569] font-light">{t("problem.h2b")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
          {cards.map((c, i) => {
            const Icon = ICONS[i] || Repeat;
            return (
              <article
                key={i}
                data-testid={`problem-card-${i + 1}`}
                className={`reveal group bg-white border border-slate-200 rounded-xl p-7 lg:p-9 hover:border-[#0B2545]/40 transition-colors ${SPANS[i]}`}
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-10 w-10 rounded-md bg-[#0B2545] flex items-center justify-center">
                    <Icon className="h-5 w-5 text-[#F9F8F6]" strokeWidth={1.5} />
                  </div>
                  <span className="font-sans-display text-xs text-slate-300 tabular-nums">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-sans-display text-xl lg:text-2xl text-[#0F172A] tracking-tight mb-3">
                  {c.title}
                </h3>
                <p className="text-[#475569] leading-relaxed">{c.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
